module.exports = __webpack_public_path__ + "img/chai_google_play.dbb8e3d6.png";